/* ============================================
   Permisos del Portal de Clientes
   Fuente única de las reglas de visibilidad por rol de contacto.
   Espejo de `api/src/lib/scope.ts` — el backend es quien manda;
   esto solo evita mostrar secciones que la API va a negar.
   ============================================ */

/**
 * ¿Este contacto ve la facturación de la empresa activa?
 *
 * La plata de la empresa la ven solo quien la representa (PRINCIPAL) y quien la
 * lleva (FACTURACIÓN). Los demás roles — TÉCNICO, COMERCIAL, GERENCIA — entran
 * al portal para operar (proyectos, hosting, apps) y no ven facturas,
 * cotizaciones ni suscripción.
 *
 * Excepción: la cuenta legada SIN contacto propio (comprador de hosting que es
 * dueño único de su cliente) es su propio titular → sí ve su facturación.
 */
export function puedeVerFacturacion(roles: string[], contactoId?: number | null): boolean {
  if (!contactoId) return true
  return roles.includes('PRINCIPAL') || roles.includes('FACTURACIÓN')
}

/** Comprar a nombre de la empresa es de PRINCIPAL / FACTURACIÓN (o titular legado). */
export const puedeComprar = puedeVerFacturacion
